import '../scrollytelling.css'
import '../v3/office.css'
import '../v4/human.css'
import '../v5/kombi.css'
import './interaktiv.css'

import { useState } from 'react'

import { SceneProvider, useScrollStory } from '../engine'
import { BeatsProvider } from '../v3/beats'
import { TOTAL_VH, atB, inB } from '../v5/beats'
import KombiStory from '../v5/KombiStory'
import { ExkursDialog, ExkursMenu, Hotspots } from './Exkurs'

const BEATS_VALUE = { inB, atB }

/**
 * Version 6 „Interaktiv“: die Kombi-Geschichte aus Version 5, dazu Hotspots
 * im Büro. Ein Klick öffnet einen Exkurs mit eigener kleiner Szene, durch die
 * man sich klickt. Über das Menü sind alle Exkurse jederzeit erreichbar.
 */
export default function ScrollytellingV6() {
  const story = useScrollStory(1, { mode: 'pin' })
  const [open, setOpen] = useState(null)
  const [seen, setSeen] = useState([])

  const show = (id) => {
    setOpen(id)
    setSeen((list) => (list.includes(id) ? list : [...list, id]))
  }

  return (
    <div ref={story.storyRef} className='sty-root off-root hum-root ix-root'>
      <section
        ref={(el) => (story.chapterRefs.current[0] = el)}
        className='off-section'
        style={{ height: `${TOTAL_VH}vh` }}
        aria-label='Finde den Menschen hinter dem Lebenslauf, interaktiv'
      >
        <div
          ref={(el) => (story.sceneRefs.current[0] = el)}
          className='off-sticky'
        >
          <SceneProvider index={0} subscribe={story.subscribe}>
            <BeatsProvider value={BEATS_VALUE}>
              <KombiStory
                lead='Erst ohne Aivy, dann mit. Tippe unterwegs auf die leuchtenden Punkte, dort zeigen wir dir, was Aivy noch kann.'
                worldExtras={<Hotspots seen={seen} onOpen={show} />}
                screenExtras={
                  <>
                    <ExkursMenu seen={seen} onOpen={show} />
                    <ExkursDialog
                      id={open}
                      onClose={() => setOpen(null)}
                      onOpen={show}
                    />
                  </>
                }
              />
            </BeatsProvider>
          </SceneProvider>
        </div>
      </section>
    </div>
  )
}
